module.exports = __webpack_public_path__ + "img/backpack.56d322f3.png";